module.exports = __webpack_public_path__ + "static/img/game_left03.4cc38613.png";